var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83337 5V1H8.16671V5H6.83337ZM5.50004 1C5.67685 1 5.84642 1.07024 5.97144 1.19526C6.09647 1.32029 6.16671 1.48986 6.16671 1.66667V5C6.16671 5.18333 6.09337 5.35 5.97004 5.47L3.77671 7.66667L3.42337 7.31333C3.33337 7.22333 3.27671 7.1 3.27671 6.96L3.28671 6.85667L3.60337 5.33333H1.50004C1.13004 5.33333 0.833374 5.03333 0.833374 4.66667V4C0.833374 3.91333 0.850041 3.83333 0.880041 3.75667L1.88671 1.40667C1.98671 1.16667 2.22337 1 2.50004 1H5.50004ZM5.50004 1.66667H2.49004L1.50004 4V4.66667H4.42671L4.05004 6.44L5.50004 4.99V1.66667Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 10V6H12.1667V10H10.8334ZM9.50004 6C9.67685 6 9.84642 6.07024 9.97144 6.19526C10.0965 6.32029 10.1667 6.48986 10.1667 6.66667V10C10.1667 10.1833 10.0934 10.35 9.97004 10.47L7.77671 12.6667L7.42337 12.3133C7.33337 12.2233 7.27671 12.1 7.27671 11.96L7.28671 11.8567L7.60337 10.3333H5.50004C5.13004 10.3333 4.83337 10.0333 4.83337 9.66667V9C4.83337 8.91333 4.85004 8.83333 4.88004 8.75667L5.88671 6.40667C5.98671 6.16667 6.22337 6 6.50004 6H9.50004ZM9.50004 6.66667H6.49004L5.50004 9V9.66667H8.42671L8.05004 11.44L9.50004 9.99V6.66667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4.5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleThumbDown);
export default __webpack_public_path__ + "static/media/double-thumb-down.84b3ef41.svg";
export { ForwardRef as ReactComponent };